import styled from "styled-components";

const WrapPasswordPage = styled.div`
  width: 100vw;
  min-height: 100vh;
  text-align: center;
  background: linear-gradient(20deg, #42c2ba, skyblue, white);

  /* background-position: center center; */

  .centerDiv {
    padding-top: 10vh;

    .logoSection {
      img {
        width: 50vw;
      }
    }

    .titleSection {
      font-size: 1.5em;
      color: white;
      font-weight: bold;
      margin-top: 10px;
    }

    .descriptionSection {
      font-size: 1em;
      color: white;
      font-weight: normal;
      margin-bottom: 30px;
    }

    .passwordSection {
      .inputField {
        &:first-child {
          margin-left: 0px;
        }
        width: 11%;
        display: inline-block;
        margin-left: 5px;
        font-size: 1.5em;
        font-weight: bold;
      }
    }

    .buttonSection {
      margin-top: 20px;
    }

    .failSection {
      margin-top: 30px;
      padding-bottom: 100px;
      color: white;
      div.title {
        margin-bottom: 10px;
      }
      button {
        margin-left: 10px;
      }
    }
  }
`;

export { WrapPasswordPage };



// WEBPACK FOOTER //
// ./src/components/login/index.styled.tsx